import React from "react";
import { Link } from "gatsby";
import brands from "../../data/brands";

/**
 * Franja de marcas. En mobile se vuelve un carrusel horizontal con snap;
 * de tablet para arriba es una grilla de ocho columnas.
 */
const BrandStrip = ({ portfolioHref = "/#belimport" }) => (
	<section id="marcas" className="anchor-target border-y border-line bg-white py-5 lg:py-6" aria-labelledby="brands-title">
		<div className="shell">
			<div className="mb-4 flex items-center justify-between lg:mb-5">
				<h2 id="brands-title" className="m-0 text-[9px] font-extrabold uppercase tracking-eyebrow text-muted">
					Nuestras marcas
				</h2>
				<Link to={ portfolioHref } className="text-[11px] font-semibold text-ink-soft transition-colors duration-200 hover:text-brand">
					Ver portafolio <span aria-hidden="true">→</span>
				</Link>
			</div>

			<div
				className="flex snap-x snap-proximity items-center overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:grid md:grid-cols-4 md:gap-y-4 md:overflow-visible lg:grid-cols-8"
				aria-label="Marcas que trabaja Belimport"
			>
				{
					brands.map((brand, index) => (
						<span
							key={ index }
							className={ `flex min-h-[40px] min-w-[125px] flex-none snap-start items-center justify-center whitespace-nowrap border-l border-line px-4 text-center leading-none tracking-[-.035em] text-[#242b39] md:min-h-[43px] md:w-auto md:min-w-0 md:flex-auto md:px-3 ${index % 4 === 0 ? "md:border-l-0 lg:border-l" : ""} ${index === 0 ? "border-l-0 lg:border-l-0" : ""} ${brand.className}` }
						>
							{ brand.name }
						</span>
					))
				}
			</div>
		</div>
	</section>
);

export default BrandStrip;
